import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module, AppModuleGroup, AppFeature } from '@/modules/core/app/constants/app.constants';
import { DashboardRoute, DashboardPathName } from '@/modules/ta/dashboard/dashboard.constants';
import { addStoreModules } from '@/store';
import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { getters } from '@/modules/core/app/helpers/store';
import SessionService from '@/modules/core/session/services/SessionService';
import Logger from '@/modules/core/app/helpers/Logger';

// This function will be the route guard
const beforeEnterDashboard = async (to, from, next) => {
  await addStoreModules(VueXHelper.getStore(), AppModuleGroup.TA);
  if (getters.session.getUserSettings()?.isFeatureAvailable(AppFeature.DASHBOARD_MANAGEMENT)) {
    next();
  } else {
    Logger.log('[DashboardRoute] Failed canAccessRoute check', Logger.LEVEL_ERROR);
    if (from && from.name) {
      return next(false);
    }
    return next(SessionService.getLoginRedirectPath());
  }
};

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${DashboardRoute.DASHBOARDS}`,
      alias: RouteGroup.CREATE_DASHBOARD,
      name: DashboardPathName.DASHBOARDS,
      component: () =>
        import(/* webpackChunkName: "dashboards-page" */ './pages/DashboardsPage.vue'),
      beforeEnter: beforeEnterDashboard,
    },
    {
      path: `/${DashboardRoute.DASHBOARDS}/templates`,
      name: DashboardPathName.DASHBOARDTEMPLATES,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-templates-and-tags-page" */ './pages/DashboardTemplatesAndTagsPage.vue'
        ),
      props: true,
      beforeEnter: beforeEnterDashboard,
    },
    {
      path: `/${DashboardRoute.LEADS}`,
      name: DashboardPathName.LEADS_DASHBOARD,
      meta: {
        isFavorite: false,
        keepAlive: false, // Don't cache the component instance
        clearMemory: true, // Signal to clear component memory on leave
      },
      component: () =>
        import(/* webpackChunkName: "dashboards-page" */ './pages/CustomDashboardPage.vue'),
      beforeEnter: beforeEnterDashboard,
    },
    {
      path: `/${DashboardRoute.DASHBOARDS}/:dashboardId`,
      name: DashboardPathName.DASHBOARD_VUE,
      meta: {
        isFavorite: false,
        keepAlive: false, // Don't cache the component instance
        clearMemory: true, // Signal to clear component memory on leave
      },
      component: () =>
        import(/* webpackChunkName: "dashboards-page" */ './pages/CustomDashboardPage.vue'),
      beforeEnter: beforeEnterDashboard,
    },
    {
      path: `/${DashboardRoute.FAV_DASHBOARDS}/:dashboardId`,
      name: DashboardPathName.DASHBOARD_VUE,
      meta: {
        isFavorite: true,
        keepAlive: false, // Don't cache the component instance
        clearMemory: true, // Signal to clear component memory on leave
      },
      component: () =>
        import(/* webpackChunkName: "fav-dashboards-page" */ './pages/CustomDashboardPage.vue'),
      beforeEnter: beforeEnterDashboard,
    },
    {
      path: `/${RouteGroup.DASHBOARDS}/test/:dashboardId`,
      redirect: (to) => `/${DashboardRoute.DASHBOARDS}/${to.params.dashboardId}`,
    },
    {
      path: `/fav/${RouteGroup.DASHBOARDS}/test/:dashboardId`,
      redirect: (to) => `/${DashboardRoute.FAV_DASHBOARDS}/${to.params.dashboardId}`,
    },
    {
      path: `/${DashboardRoute.DASHBOARD}/:dashboardId`,
      redirect: (to) => {
        const { dashboardId } = to.params;
        if (dashboardId === 'templates') {
          return undefined; // don’t redirect, use existing matching route
        }
        return `/${DashboardRoute.DASHBOARDS}/${dashboardId}`;
      },
    },
    {
      path: `/fav/${DashboardRoute.DASHBOARD}/:dashboardId`,
      redirect: (to) => `/${DashboardRoute.FAV_DASHBOARDS}/${to.params.dashboardId}`,
    },
  ],
  Module.DASHBOARD
);
